export default (weddingConfig, editingKeys) =>
  weddingConfig.weddingContent.contentPages.filter(page => page.pageType === editingKeys.contentPage)[0];
